
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './i18n/LanguageContext';
import RegistrationPage from './pages/RegistrationPage';
import AdminPage from './pages/AdminPage';
import PublicCardsPage from './pages/PublicCardsPage';
import CardsGalleryPage from './pages/CardsGalleryPage';

export default function App() {
  return (
    <LanguageProvider>
    <Router>
      <Routes>
        <Route path="/" element={<RegistrationPage />} />
        <Route path="/quiz" element={<RegistrationPage isDirectQuiz={true} />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/cards" element={<CardsGalleryPage />} />
        <Route path="/cards/:recordId" element={<PublicCardsPage />} />
        <Route path="/u/:recordId" element={<PublicCardsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
    </LanguageProvider>
  );
}
